import * as React from "react";
import { Button } from "@grandvisionhq/elements";
import { slugify } from "@grandvisionhq/utils";
import { Variant } from "./types.js";
/* empty css                 */
const renderAction = (index, labels, action) => index === labels.lines.length - 1 && action !== void 0 && labels.action !== void 0 && labels.action.length > 0;
const NoTimeSlots = ({ variant, labels, action }) => variant !== Variant.none ? /* @__PURE__ */ React.createElement(React.Fragment, null, labels.lines.map((line, i) => /* @__PURE__ */ React.createElement("p", { key: slugify(line), className: "no-time-slots__line" }, /* @__PURE__ */ React.createElement("span", { className: "no-time-slots__line-text" }, line, " "), renderAction(i, labels, action) ? /* @__PURE__ */ React.createElement(Button, { className: "no-time-slots__line-action", variant: "ghost", onClick: action }, labels.action) : null))) : null;
export {
  NoTimeSlots as default
};
//# sourceMappingURL=NoTimeSlots.js.map
